<div class="d-flex flex-column h-100 overflow-auto no-scrollbar">
  <ex-module-home class="module-home-button"> </ex-module-home>

  <div class="d-flex flex-column">
    <ng-container *ngFor="let item of displayedMenuItems">
      <ex-menu-item
        class="menu-item"
        [label]="item.label"
        [iconName]="item.phIconName"
        [module]="'' + item.mainModule"
        [menuItemRouterLink]="item.routerLink"
      ></ex-menu-item>
    </ng-container>
  </div>

  <div class="d-flex flex-grow-1"></div>

  <div class="d-flex flex-column">
    <ng-container *ngFor="let item of accountMenuItems">
      <ex-menu-item
        class="account-menu-item"
        [label]="item.label"
        [iconName]="item.phIconName"
        [module]="'' + item.mainModule"
        [menuItemRouterLink]="item.routerLink"
        (click)="onClickAccountMenuItem(item)"
      ></ex-menu-item>
    </ng-container>
  </div>

  <ex-module-home *ngIf="alternativeExplainMainModule" linkToOtherModule> </ex-module-home>
</div>
